import createActions from 'utils/redux/createActions'

export default createActions([
	'TOGGLE_TOOLTIP'
  , 'CLOSE_TOOLTIP'
  , 'CLOSE_ALL_TOOLTIPS'
])



// WEBPACK FOOTER //
// ./src/actions/tooltipsActions.js